import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpclientService } from "../../../shared";
import { UserFavoritesRequest } from "../services/Info/UserFavoritesRequest";

@Injectable()
export class NavNotificationService {
	constructor(private httpclientService: HttpclientService) {}

	AttendanceVerifyStudentList(EntryDate) {
		var postResult$ = new Subject();
		var url = "attendance/AttendanceVerifyStudentList?EntryDate=" + EntryDate;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ClassAttendanceModify(lstClass, ClassDate) {
		var postResult$ = new Subject();
		var url = "attendance/ClassAttendanceModify";

		var params = { lstClass: lstClass, ClassDate: ClassDate };

		var promise$ = this.httpclientService.post(url, params);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	getPager(totalItems: number, currentPage: number = 1, pageSize: number = 3) {
		// calculate total pages
		let totalPages = Math.ceil(totalItems / pageSize);

		// ensure current page isn't out of range
		if (currentPage < 1) {
			currentPage = 1;
		} else if (currentPage > totalPages) {
			currentPage = totalPages;
		}

		let startPage: number, endPage: number;
		if (totalPages <= 10) {
			// less than 10 total pages so show all
			startPage = 1;
			endPage = totalPages;
		} else {
			// more than 10 total pages so calculate start and end pages
			if (currentPage <= 6) {
				startPage = 1;
				endPage = 10;
			} else if (currentPage + 4 >= totalPages) {
				startPage = totalPages - 9;
				endPage = totalPages;
			} else {
				startPage = currentPage - 5;
				endPage = currentPage + 4;
			}
		}

		// calculate start and end item indexes
		let startIndex = (currentPage - 1) * pageSize;
		let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

		// create an array of pages to ng-repeat in the pager control
		let pages = Array.from(Array(endPage + 1 - startPage).keys()).map((i) => startPage + i);

		// return object with all pager properties required by the view
		return {
			totalItems: totalItems,
			currentPage: currentPage,
			pageSize: pageSize,
			totalPages: totalPages,
			startPage: startPage,
			endPage: endPage,
			startIndex: startIndex,
			endIndex: endIndex,
			pages: pages,
		};
	}

	UserFavoriteInsertByID(parms: UserFavoritesRequest) {
		var postResult$ = new Subject();
		var url = "Dashboard/UserFavoriteInsertByID";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserFavoriteDeleteByID(parms: UserFavoritesRequest) {
		var postResult$ = new Subject();
		var url = "Dashboard/UserFavoriteDeleteByID";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	NavbarPreferenceSelect() {
		var postResult$ = new Subject();
		var url = "Dashboard/NavbarPreferenceSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
